import React, { useEffect, useState } from 'react';
import ReactTurntable from "react-turntable"
import './styles/common.css';
import './styles/index.css';
import './styles/game.css';

function getCouponAll() {
  return fetch('https://shopxyz.online/api/1.0/coupon/all')
          .then((response) => response.json());
}

function postCoupon(data, aws_JWT) {
  return fetch('https://shopxyz.online/api/1.0/user/coupon', {
      body: JSON.stringify(data),
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${aws_JWT}`,
      }),
      method: 'POST',
  }).then((response) => response);
}

function confirmCoupon(prizeTitle, data, aws_JWT){
    let confirmAction = window.confirm(`你抽到的是：${prizeTitle}`);
    if (confirmAction) {
      alert("coupon已存入");
      postCoupon(data, aws_JWT);
    } else {
      alert("coupon飛了");
    }
}

export default function Game() {
  const [aws_JWT] = useState(window.localStorage.getItem('aws_JWT'));
  const [prizesData, setPrizesData] = useState();
    
  const gameWidth = 400;
  const styles = {
      // justifyContent:"center",
      // alignContent:"center",
      // display:"flex"
  }
  
  const prizes = [
      '💎', 
      '👑',
      '🏆',
      '🔄', 
      '💵',
      '❌' 
  ]
  
  const options = {
      prizes,
      width: gameWidth,
      height: gameWidth,
      primaryColor: "#f4f3ee",
      secondaryColor: "#d3d3d3",
      fontStyle:{
          color:"#000",
          size:"50px",
          fontVertical:true,
          fontWeight:"bold",
          fontFamily:"Microsoft YaHei"
      },
      speed : 5000,
      duration:5000,
      clickText:"",
      onStart(){
        //If you want before the rotate do some...
        console.log('start...');
        //If you want stop rotate you can return false
        if (!prizesData){
          alert('你網路比較慢，資料還在路上，請再試一次')
          return false;
        }
        return true
      },
      onComplete(prize){
        if (prize !== '❌'){
          let prizeIndex = prizes.indexOf(prize);
          let prizeGet = prizesData[prizeIndex];
          let prizeSend = 
            [{
              coupon_id: prizeGet.id,
              amount: prizeGet.amount,
              source: prizeGet.source,
              title: prizeGet.title
            }
            ]
          console.log(prizeSend);
          confirmCoupon(prizeSend[0].title, prizeSend, aws_JWT);
      } else {
        alert('ㄏㄏ');
      }
      }
  }

    useEffect(()=> {
      getCouponAll().then((res) => setPrizesData(res));
    },[])

    if (!aws_JWT) {
      alert('登入才能玩啦!!!!!!!!!');
      window.location.replace('./');
  } else {
    return (
      <>
      <div className='game' style={styles}>
          <ReactTurntable {...options} />
      </div>
      </>
  )
  }
}
